import './styles.scss';

import classNames from 'classnames';
import * as React from 'react';
import { branch, compose } from 'recompose';

import withIcon, { IWithIcon } from '../../hocs/withIcon';
import IMPComponent from '../interfaces/IMPComponent';
import { ISvgIconGeneralProps } from '../SvgIcon';

export interface IButtonProps extends IMPComponent, IWithIcon, React.AllHTMLAttributes<HTMLButtonElement> {
  /**
   * Button content
   */
  children?: React.ReactNode;
  /**
   * Block level button
   */
  block?: boolean;
  type?: 'button' | 'reset' | 'submit';
  outline?: boolean;
  color?: string;
  iconName?: string;
  disabled?: boolean;
  openFile?: boolean;
  href?: string;
}

const enhance = compose<IButtonProps, IButtonProps & ISvgIconGeneralProps>(
  React.memo,
  branch(({ iconName }) => {
    return Boolean(iconName);
  }, withIcon('Button')),
);

const Button: React.FunctionComponent<IButtonProps> = ({
  children,
  className,
  block,
  outline,
  type,
  color,
  disabled,
  openFile,
  href,
  ...props
}) => {
  const cn = classNames('Button', className, {
    'Button--block': block,
    'Button--outline': outline,
    'Button--disabled': disabled,
    'Button--file': openFile,
    [`Button--${color}`]: color,
  });

  if (openFile) {
    return (
      <label className={cn}>
        <input type="file" className="Button-fileInput" disabled={disabled} {...(props as any)} />
        <span className="Button-fileInputText">{children}</span>
      </label>
    );
  }

  if (href) {
    return (
      <a href={href} className={cn} {...(props as any)}>
        {children}
      </a>
    );
  }

  return (
    <button className={cn} type={type} disabled={disabled} {...props}>
      {children}
    </button>
  );
};

Button.defaultProps = {
  block: false,
  className: '',
  color: '',
  outline: false,
  openFile: false,
  type: 'button',
  disabled: false,
};

export default enhance(Button);



// WEBPACK FOOTER //
// ./src/components/Button/index.tsx